export default {
  shouldUseOnlyUSAPhoneNumber: 'Please use only US phone number like this +11234567890.',
  USAPhoneNumberLength: (length) => `Phone number should be 10 digits after county code (+1), but your is ${length}`,
  invalidEmail: 'Please enter valid E-mail address.',
  shouldAgreeWithSMSAgreement:
    'Your consent to the sms agreement is required. Otherwise, you cannot register for the service.',
  shouldAgreeWithPrivacy:
    'Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.',
  eventNotExist: (eName) => `This "${eName}" event name (eName) doesn't exist. Please use right event name`,
  wrongLink: 'You are open a wrong link. Please open right link.',
  connectionError: 'Connection Error. Check your internet and try again.',
};
